// eslint-disable-next-line import/prefer-default-export
export const Tables = {
  RevenueByCategory: 0b1,
  CategoryRevenueForAllStylists: 0b10,
  SalonRevenueByStylist: 0b100,
  CategoryByStylist: 0b1000,
  FutureRevenueByCategory: 0b10000,
  FutureRevenueByStylist: 0b100000,
  FutureRevenueCombinedForStylist: 0b1000000,
  BookingsByOrigin: 0b10000000,
  BookingsByStatus: 0b100000000,
  RebookingRate: 0b1000000000,
  CashCardByStylist: 0b10000000000,
  CountOfServices: 0b100000000000,
  CategoryServiceAndProduct: 0b1000000000000,
  ClientVisitsFrequency: 0b10000000000000,
  CashCardSplitByClient: 0b100000000000000,
  UniqueClientVisits: 0b1000000000000000,
  WorkingHoursStylist: 0b10000000000000000,
  HoursWorkedByCategory: 0b100000000000000000,
  HoursWorkedByStylistByCategoryAndService: 0b1000000000000000000,
};
